<script setup lang="ts">
defineProps<{
  variant?: "improved" | "alert" | "info";
  label: string;
  value: string | number;
  detail?: string;
}>();
</script>

<template>
  <div
    class="summary-card"
    :class="{
      'border-l-[#389162]': variant === 'improved',
      'border-l-[#b60007]': variant === 'alert',
      'border-l-[#2c5aa0]': variant === 'info',
    }"
  >
    <div class="summary-card-label">
      {{ label }}
    </div>
    <div class="summary-card-value">{{ value }}</div>
    <div v-if="detail" class="dashboard-text-secondary mt-1 text-[13px]">
      {{ detail }}
    </div>
    <div v-if="$slots.detail" class="dashboard-text-secondary mt-1 text-[13px]">
      <slot name="detail" />
    </div>
  </div>
</template>
